const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const getOnsiteItems = (onsiteChargesInfo) =>
  (Array.isArray(onsiteChargesInfo) ? onsiteChargesInfo : [])
    .filter((item) => item?.id && item?.label && item.active !== false)
    .map((item) => ({
      ...item,
      category: item.category || "Others",
      unit: item.unit || "",
      price: toNumber(item.price),
      hsnCode: item.hsnCode || "",
      amountEntry: !!item.amountEntry,
    }));
